import React from 'react';

import Header from './header';
import Banner from './bannerBlank';
import Team from './team';
import Footer from './footer';

function Help() {
  return (
    <div >
     <Header />
     <Banner />
     <Team />
     <Footer />
    </div>
  );
}

export default Help;